export default __webpack_public_path__ + "static/media/leads.cb33f8f7.svg";